// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"Header_inputSearch__1P9qW","nav":"Header_nav__31sRW"};